import './accessibility.js'
import './alert.js'
import './animate.js'
import './bg.js'
import './fix-height.js'
import './header.js'
import './lightbox.js'
import './modal.js'
import './paragraph--faq.js'
import './paragraph--galerie.js'
import './smooth-scroll.js'
import './tabs.js'
